// import { Sample } from '~/views/sample-view';
import { FC } from 'react';
import { ContentStyled } from './styled';

type Props = {
  children?: React.ReactNode;
};
export const Content: FC<Props> = ({ children }) => {
  return <ContentStyled>{children}</ContentStyled>;
};
